export const setChatFlows = (chatFlows) => ({
    type: "SET_CHAT_FLOWS",
    payload: chatFlows,
  });

export const setWhatsAppFlows = (whatsAppFlows) => ({
    type: "SET_WHATSAPP_FLOWS",
    payload: whatsAppFlows,
  });